import Select, { ActionMeta, SingleValue, StylesConfig } from "react-select"

export type PlantSelectOption = { value: number; label: string; color?: string }

const dot = (color = "transparent") => ({
	alignItems: "center",
	display: "flex",

	":before": {
		backgroundColor: color,
		borderRadius: 10,
		content: '" "',
		display: "block",
		marginRight: 8,
		height: 10,
		width: 10,
	},
})

const colourStyles: StylesConfig<PlantSelectOption> = {
	control: (styles) => ({ ...styles, backgroundColor: "white" }),
	option: (styles, { data, isDisabled, isFocused, isSelected }) => {
		const color = data.color
		return {
			...styles,
			backgroundColor: isDisabled
				? undefined
				: isSelected
					? `${color ?? "#2b4861"}33`
					: isFocused
						? `${color ?? "#2b4861"}11`
						: undefined,
			color: isDisabled
				? "#ccc"
				: isSelected
					? color
					: // ? chroma.contrast(color, "white") > 2
						// 	? "white"
						// 	: "black"
						color,
			cursor: isDisabled ? "not-allowed" : "default",

			":active": {
				...styles[":active"],
				backgroundColor: !isDisabled ? (isSelected ? color : `${color}55`) : undefined,
			},
		}
	},
	input: (styles) => ({ ...styles, ...dot() }),
	placeholder: (styles) => ({ ...styles, ...dot("#ccc") }),
	singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color ?? "#00aa00") }),
}
export default function PlantSelector({
	options,
	onChange,
	value,
}: {
	options: PlantSelectOption[]
	value: PlantSelectOption
	onChange: (
		newValue: SingleValue<PlantSelectOption>,
		actionMeta: ActionMeta<PlantSelectOption>
	) => void
}) {
	return (
		<Select
			value={value}
			isMulti={false}
			onChange={onChange}
			options={options}
			styles={colourStyles}
		/>
	)
}
